<div class="textslist">
  @for (text of this.textsList; track text; let index = $index) {
<div>
    <app-text-list-item
      [itemIndex]="index"
      [detailsCollapsed]="this.currentItemShowing !== index"
      [textDetails]="text"
      [todo]="this.todo"
      [phasesVocales]="this.phasesVocales"
      [standbyTypes]="this.standbyTypes"
      (showDetailsEvent)="this.showDetails($event)"
      (showCommentDialogEvent)="this.onShowCommentDialog($event)"
      (showStandbyDialogEvent)="this.onShowStandbyDialog($event)"
      (showTranslateDialogEvent)="this.onShowTranslateDialog($event.translation, $event.translatedText)"
    />
  </div>
}
</div>
